import { getElement } from '../ui/dom'

let tracked = new Set()
let trackingInterval = null
let globalLogger = null
const urlParams = new URLSearchParams(window.location.search)
const screenUuid = urlParams.get('screenUuid')

// Function to set global logger from index.js
export const setGlobalLoggerInVideoTracking = (logger) => {
  globalLogger = logger
}

export const handleVideoTracking = (adData) => {
  const videoElement = getElement('video-content')

  trackingInterval = setInterval(() => {
    if (!videoElement.duration || videoElement.paused || videoElement.ended) {
      return
    }

    const percent = (videoElement.currentTime / videoElement.duration) * 100

    if (percent >= 25 && !tracked.has('firstQuartile')) {
      tracked.add('firstQuartile')
      console.log('Video: FirstQuartile')
      addVideoEvent('video_playback_first_quartile', videoElement, adData, {
        progress_percentage: 25,
        current_time: videoElement.currentTime
      })
    }

    if (percent >= 50 && !tracked.has('midpoint')) {
      tracked.add('midpoint')
      console.log('Video: Midpoint')
      addVideoEvent('video_playback_midpoint', videoElement, adData, {
        progress_percentage: 50,
        current_time: videoElement.currentTime
      })
    }

    if (percent >= 75 && !tracked.has('thirdQuartile')) {
      tracked.add('thirdQuartile')
      console.log('Video: ThirdQuartile')
      addVideoEvent('video_playback_third_quartile', videoElement, adData, {
        progress_percentage: 75,
        current_time: videoElement.currentTime
      })
    }
  })
}

export const clearVideoTracking = () => {
  if (trackingInterval !== null) {
    clearInterval(trackingInterval)
    trackingInterval = null
  }
  tracked.clear()
}

export const addVideoEvent = (eventName, videoElement, adData, params = {}) => {
  if (globalLogger) {
    globalLogger.addEvent(eventName, {
      ...params,
      content_type: 'video',
      video_duration: videoElement.duration,
      url: adData?.url ?? videoElement.src,
      adexchange_id: adData?.source?.adexchange_id,
      autoplay: !videoElement.paused,
      screen_uuid: screenUuid,
      type: adData?.source?.type,
      timestamp: new Date().toISOString(),
      id: adData?.id
    })
  }
}
